// extracted by css-extract-rspack-plugin
export default {"widgets":"WidgetGroupContent_widgets__aX5wc","gridContainer":"WidgetGroupContent_gridContainer__p4cQ6","gridDropOverlay":"WidgetGroupContent_gridDropOverlay__w4T0T"};